<!--搜索界面-->
<template>
  <div class="search-container">
    <search-index/>
    <div class="search-menu">
      <span class="postion-logo">
        <div class="logo"></div>
        <span class="title-logo">全国企业服务网</span>
      </span>
      <el-input placeholder="请输入搜索内容" v-model="keyword" class="input-with-select"
                style="width: 41%;margin-left: 45px;float:left;" @keyup.enter.native="getSearchSmeList">
        <template slot="prefix">
          <i slot="prefix" class="el-icon-search"/>
        </template>
        <el-button type="danger" slot="append" @click="getSearchSmeList">搜一下</el-button>
      </el-input>
    </div>
    <div class="fiexd-content">
      <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
        <el-menu-item v-for="menu of menuItem" :index="menu.method">{{ menu.name }}</el-menu-item>
      </el-menu>
    </div>
    <p class="statistics">为你找到相关结果 {{ tablePage.total }} 条</p>
    <div class="search-content" :style="'min-height:'+height_min+'px;'" v-if="pageList.length>0">
      <template v-for="list of pageList">
        <div class="info-list" v-if="list.method_type!='recruitment'">
          <!--用户-->
          <user v-if="list.method_type=='users' && list.type!=3" :options="list" @click="details(list)"/>
          <policy v-else-if="list.type!=3" :options="list" @click="details(list)"/>
        </div>
        <div class="info-list" v-else>
          <div class="table-group" @click="positionDetails(list)">
            <div class="table-header">
              <div class="table-group-th">
                <span class="bold-span">{{ list.title }}</span>
                <span class="red-span">{{ list.salary }}</span>
              </div>
              <div class="table-group-td">
                <span class="normal-span">{{ list.workArea }}</span>
                <el-divider direction="vertical"/>
                <span class="normal-span">{{ list.workingYears }}</span>
                <el-divider direction="vertical"/>
                <span class="normal-span">{{ list.education }}</span>
              </div>
            </div>
            <div class="table-bottom">
              <el-avatar fit="cover" :src="list.image"  :size="48"/>
              <div style="padding-left: 10px;">
                <p>{{ list.identity_type_name }}</p>
                <span class="normal-span">{{ list.businessNature }}</span>
                <span class="normal-span" v-if="list.companyScale"><el-divider
                    direction="vertical"/>{{ list.companyScale }}</span>
              </div>
            </div>
          </div>
        </div>
      </template>
      <!-- 分页 -->
      <page :total="tablePage.total" class="pagination" @currentPage="currentPage" :page="tablePage.currentPage"
            :limit="tablePage.pageSize" style="padding: 10px 0px"/>
    </div>
    <div class="search-content" :style="'min-height:'+height_min+'px;'" v-else>
      <el-empty description="暂无内容"/>
    </div>
    <hang/>
    <home_footer/>
  </div>
</template>

<script>
import Hang from "@/components/Hang/Hang";
import home_footer from '@/components/footer/home_footer';
import page from "@/components/page/pages";
import user from "@/components/searchMenu/user";
import policy from "@/components/searchMenu/policy";
import {searchCategory, searchSmeList} from '@/api/interfaceApi'
import cityJson from "@/static/cityJson.json";
import searchIndex from "@/components/header/searchheader";

export default {
  name: "search",
  components: {searchIndex, Hang, page, home_footer, user, policy},
  data() {
    return {
      keyword: '',
      height_min: document.documentElement.clientHeight - 391,
      menuItem: [],
      activeIndex: 'comprehensive',
      /*分页*/
      tablePage: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      pageList: [],
      cityList: {
        id: 500000,
        lat: 29.563707,
        level: 1,
        lng: 106.550483,
        name: "重庆",
        pid: 0,
        short_name: "重庆",
        prefix: 'cq',
        abridge: '渝'
      },
      cid: 0,
    }
  },
  mounted() {
    this.getSearchCategory();
    this.getSearchSmeList();
  },
  methods: {
    /*切换分类*/
    handleSelect(key, keyPath) {
      this.activeIndex = key;
      this.tablePage.currentPage = 1;
      this.getSearchSmeList();
    },
    /*返回到首页*/
    homeIndex() {
      this.$router.replace({
        path: '/'
      })
    },
    /*获取搜索分类*/
    getSearchCategory() {
      searchCategory().then(res => {
        if (res.code == 200) {
          this.menuItem = res.content;
        }
      })
    },
    /*搜索*/
    getSearchSmeList() {
      this.pageList = [];
      searchSmeList({
        city: this.cityList.id,
        keyword: this.keyword,
        page: this.tablePage.currentPage,
        pageLimit: this.tablePage.pageSize,
        search_method: this.activeIndex,
        uid: this.cid
      }).then(res => {
        if (res.code == 200) {
          this.pageList = res.content;
          this.tablePage.total = res.total;
        }
      })
    },
    //切换分页
    currentPage(page) {
      this.tablePage.currentPage = page;
      this.getSearchSmeList();
    },
    /*招聘详情*/
    positionDetails(row){
      let routeData = this.$router.resolve({
        name: "positionDetail",
        query: {id: row.id},
        path: '/serviceNet/positionDetails'
      });
      window.open(routeData.href, '_blank')
    }
  },
  beforeMount() {
    this.keyword = this.$route.query.keyword;
    this.cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
    if (sessionStorage.getItem('setPositioning'))
      this.cityList = JSON.parse(sessionStorage.getItem('setPositioning'));
    else {
      let cityList = JSON.parse(sessionStorage.getItem('locationInfo'));
      for (let li of cityJson) {
        if (cityList.short_name == li.short_name)
          this.cityList = li;
      }
    }
  }
}
</script>
<style scoped>
.search-container >>> .search-menu .el-input__inner {
  background-color: #ffffff;
  border-radius: 8px 0px 0px 8px;
  border: 1px solid #DDDDDD;
  color: #333333;
  font-size: 16px;
  height: 55px;
  line-height: 55px;
  padding: 0 50px;
  border-right: none;
}

.search-container >>> input::-webkit-input-placeholder {
  color: #AAAAAA;
}

.search-container >>> .el-input__suffix {
  display: flex;
  align-items: center;
  right: 10px;
}

.search-container >>> .el-icon-search {
  font-size: 19px;
}

.search-container >>> .el-input__prefix {
  left: 20px;
  color: #666666;
  font-size: 33px;
}

.search-container >>> .el-input-group__append, .el-input-group__prepend {
  background-color: #FE273B;
  color: #ffffff;
  border: 1px solid #ffffff;
  border-radius: 0px 8px 8px 0px;
  padding: 0 32px;
}

.search-container >>> .el-menu--horizontal > .el-menu-item {
  float: left;
  height: 48px;
  line-height: 48px;
  margin: 0 20px;
  color: #333333;
  font-weight: 500;
  font-size: 16px;
  padding: 0px;
}

.search-container >>> .el-menu--horizontal > .el-menu-item.is-active {
  color: #FE273B;
}

.search-container >>> .el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
  color: #999999;
}

.search-container >>> .el-menu.el-menu--horizontal {
  border-bottom: none;
}

.search-container >>> .el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: 2px solid #FE273B;
}
</style>
<style scoped lang="scss">
.search-container {
  background: #ffffff;

  .search-menu {
    position: fixed;
    min-width: 76rem;
    padding: 17px 18%;
    top: 63px;
    background: white;
    z-index: 99;

    .postion-logo {
      display: flex;
      width: auto;
      float: left;

      .title-logo {
        color: #333333;
        font-size: 24px;
        font-weight: 500;
        padding-left: 20px;
        line-height: 46px;
      }

      .logo {
        background: url("~@/assets/img/home/矢量智能对象.png") no-repeat;
        width: 48px;
        height: 48px;
        background-size: 100% 100%;
      }
    }

    .postion-link {
      float: right;
      margin-right: 40px;
      line-height: 52px;

      .link-right {
        margin-left: 45px;
        color: #333333;
      }
    }
  }

  .fiexd-content {
    padding: 0px 18%;
    position: fixed;
    top: 152px;
    background: white;
    z-index: 99;
    min-width: 76rem;
    border: 1px solid #DDDDDD;
  }

  .search-content {
    padding: 0px 18%;
    min-height: 545px;

    .info-list {
      padding-top: 20px;
      .table-group {
        background: #ffffff;
        padding-bottom: 20px;
        border-bottom: 1px solid #E7E9F5;


        .table-header {
          border-bottom: 1px solid #f5f5f5;
          .table-group-th {
            display: flex;
            justify-content: space-between;

            .bold-span {
              color: #333333;
              font-size: 18px;
              font-weight: bold;
              font-family: 'SourceHanSansCN';
            }

            .red-span {
              color: #FE273B;
              font-size: 18px;
              font-family: 'SourceHanSansCN';
            }
          }

          .table-group-td {
            line-height: 45px;

            .el-divider {
              background-color: #999999;
            }

            .normal-span {
              color: #333333;
              font-family: 'SourceHanSansCN';
              font-size: 14px;
            }
          }
        }

        .table-bottom {
          display: flex;
          align-items: center;
          p {
            margin-block-start: 10px;
            margin-block-end: 5px;
          }

          .el-divider {
            background-color: #999999;
          }

          .normal-span {
            color: #666666;
            font-family: 'SourceHanSansCN';
            font-size: 14px;
          }
        }
      }
    }
  }

  .statistics {
    margin-block-start: 0em;
    margin-block-end: 0em;
    padding: 210px 0px 10px 18%;
    background: #f1f1f1;
    color: #999999;
  }
}
</style>